export default "__VITE_ASSET__BCiZA$3a__"